export default __webpack_public_path__ + "static/media/background-mobile.e97e3e94.svg";